import Breadcrumb from "../Pages/Breadcrumb";
import { Airplay, Award, Bot, GraduationCap, HandCoins, ListRestart, Lock, MonitorCog, SquareStack, UserCheck, Users } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function Diploma() {
    const { t } = useTranslation();
    const whyIvory = t('diploma.whyIvory', { returnObjects: true })
    const whyIvoryIcons = [<Airplay />, <ListRestart />, <HandCoins />, <Award />, <GraduationCap />, <UserCheck />];

    const diplomas = t('diploma.diplomas', { returnObjects: true })
    const diplomasIcons = [<Lock />, <Bot />, <SquareStack />, <Users />, <MonitorCog />];

    return (
        <>
            <Breadcrumb pages={[t('routes.services'), t('routes.diploma')]} />
            <main className="container my-8">
                <section className="relative border rounded-lg text-start px-3 py-10">
                    <div className="flex justify-center items-center">
                        <div className="absolute -top-4 bg-primary-tw text-white w-9/12 !py-3 rounded-xl text-center *:m-0">
                            <p className="text-xl">
                                {t('diploma.header')}
                            </p>
                            <p className="text-sm mt-2">
                                {t('diploma.header-desc')}
                            </p>
                        </div>
                    </div>
                    <div className="mt-10 p-4 lg:px-12">
                        <article className="text-justify text-gray-600">
                            {t('diploma.desc')}.
                        </article>
                    </div>
                    <div className="grid place-items-center">
                        <button className="bg-secondary-tw absolute -bottom-4 text-white w-36 rounded-lg !py-2">
                            {t('diploma.start-now')}
                        </button>
                    </div>
                </section>
            </main>

            <main className="bg-light-gray py-4 container">
                <div className="grid place-items-center">
                    <p className="services-header grid place-items-center after:-bottom-2 after:w-24">
                        {t('about.why')}
                    </p>
                </div>
                <div className="grid gap-8 lg:grid-cols-2 xl:grid-cols-3 my-8">
                    {
                        whyIvory.map((item, i) => (
                            <div key={i} className="relative border-2 rounded-lg p-4">
                                <div className="grid place-items-center">
                                    <div className="absolute -top-5 bg-secondary-tw rounded-full size-10 grid place-items-center text-white">
                                        {whyIvoryIcons[i]}
                                    </div>
                                </div>
                                <div className="text-center my-4 *:m-0">
                                    <p>
                                        {item.title}
                                    </p>
                                    <span className="text-sm text-gray-500">
                                        {item.desc}
                                    </span>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </main>

            <main className="container">
                <div className="grid place-items-center">
                    <p className="services-header grid place-items-center after:-bottom-2 after:w-24">
                        {t('routes.diploma')}
                    </p>
                </div>
                <div className="grid gap-8 lg:grid-cols-2 xl:grid-cols-5 mt-8">
                    {
                        diplomas.map((item, i) => (
                            <div key={i} className="relative border-2 rounded-lg p-4 bg-secondary-tw text-white">
                                <div className="grid place-items-center">
                                    <div className="absolute -top-5 bg-secondary-tw border border-white rounded-full size-10 grid place-items-center text-white">
                                        {diplomasIcons[i]}
                                    </div>
                                </div>
                                <div className="text-center my-4 *:m-0">
                                    <p>
                                        {item.title}
                                    </p>
                                    <span className="text-sm text-gray-100">
                                        {item.desc}
                                    </span>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </main>
        </>
    )
}